import t from "@/lang/lang";
import { FieldErrors } from "@/shared/components/field/field";
import { Field, FieldLabel } from "@/shared/components/ui/field";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { useFieldErrors } from "@/shared/lib/errors/err-validation-failed-context";
import { useOmniScopeOfWorkBaseDataListQuery } from "../api/base-data-api";
import { ScopeOfWorkBaseData } from "../types/base-data";

// standardValue selects no instance: the backend takes the default.
const standardValue = "standard";

/**
 * ScopeOfWorkBaseDataSelect selects the base data of the company and
 * service kind filling a new scope of work. onBaseDataChange receives
 * undefined for the default of the company.
 */
export function ScopeOfWorkBaseDataSelect({
  companyId,
  serviceKind,
  value,
  onBaseDataChange,
  fieldName,
}: {
  companyId: string;
  serviceKind: string;
  value?: string;
  onBaseDataChange: (baseData?: ScopeOfWorkBaseData) => void;
  fieldName?: string;
}) {
  const { data } = useOmniScopeOfWorkBaseDataListQuery({
    company: { active: true, values: [companyId] },
    serviceKind: { active: true, values: [serviceKind] },
  });
  const instances = data?.items ?? [];

  const { errors, invalid, reset } = useFieldErrors(fieldName);

  return (
    <Field data-invalid={invalid || undefined}>
      <FieldLabel>{t("Vorlage")}</FieldLabel>
      <Select
        value={value ?? standardValue}
        onValueChange={(id) => {
          reset();
          onBaseDataChange(instances.find((b) => b.id === id));
        }}
      >
        <SelectTrigger aria-invalid={invalid || undefined}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value={standardValue}>
              {t("Standard")}
              <span className="text-muted-foreground text-sm">
                {t("(gesetzter Standardkatalog)")}
              </span>
            </SelectItem>
            <SelectSeparator />
            {instances.map((b) => (
              <SelectItem key={b.id} value={b.id}>
                {b.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <FieldErrors errors={errors} />
    </Field>
  );
}
